import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, ImageIcon } from "lucide-react";
import { toast } from "sonner";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

export default function ImagePicker({ value, onChange, testid = "image-picker" }) {
  const [lib, setLib] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const load = async () => { try { setLib((await api.get("/media/library")).data); } catch (e) {} };
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post("/media/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      await load();
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const full = value ? (value.startsWith("http") ? value : ORIGIN + value) : "";

  return (
    <div className="flex gap-2 items-center">
      <div className="w-11 h-11 rounded-lg bg-secondary border border-white/10 flex items-center justify-center overflow-hidden shrink-0">
        {full
          ? <img src={full} alt="" className="w-full h-full object-cover" data-testid={`${testid}-preview`} />
          : <ImageIcon className="w-4 h-4 text-muted-foreground" />}
      </div>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="flex-1 bg-secondary border border-white/10 rounded-lg px-2 py-2 text-sm text-foreground focus:ring-primary focus:outline-none"
      >
        <option value="">No image</option>
        {lib.map((s) => <option key={s.id} value={s.url}>{s.name}</option>)}
      </select>
      <Button type="button" size="sm" onClick={() => fileRef.current.click()} disabled={uploading} className="bg-cookie text-black hover:bg-cookie/90" data-testid={`${testid}-upload`}>
        <Upload className="w-4 h-4 mr-1" />{uploading ? "…" : "Upload"}
      </Button>
      <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/gif,image/webp" className="hidden" onChange={upload} />
    </div>
  );
}
